import { AnyAction, Dispatch } from 'redux';
import { SidePanelState } from '../reducer/sidePanelReducer';
import { translate } from '../../i18n/translate';
import {
  PiFileTextLight,
  PiUserPlusLight,
  PiSlidersHorizontalLight,
} from 'react-icons/pi';

export const showSidePanel = (payload: SidePanelState): AnyAction => ({
  type: 'SHOW_SIDE_PANEL',
  payload,
});

export const hideSidePanel = (): AnyAction => ({
  type: 'HIDE_SIDE_PANEL',
});

export const expandSidePanel = (): AnyAction => ({
  type: 'EXPAND_SIDE_PANEL',
});

export const collapseSidePanel = (): AnyAction => ({
  type: 'COLLAPSE_SIDE_PANEL',
});

export const updateSidePanel = (payload: Partial<SidePanelState>): AnyAction => ({
  type: 'UPDATE_SIDE_PANEL',
  payload,
});

export const showAddClientSidePanel = (onClientCreated?: (client: any) => void) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'addClient',
        showSidePanel: true,
        size: 'md',
        onCancel: () => dispatch(hideSidePanel()),
        onClientCreated: onClientCreated,
        icon: <PiUserPlusLight className='w-6 h-6 text-gray-600' />,
        /*
          THE ENTITY IS A CONTACT. "Client" is a TYPE a contact can have - on
          a matter you add a client-contact - so it is a value in the Contact
          Type field, not the name of the thing being created. The form inside
          this panel has said "Create New Contact" for a while; only its own
          header still said Client, so the panel and the form it contains
          disagreed about what the user was making. (The old copy also read
          "detals".)
        */
        message: translate('Create New Contact'),
        subMsg: translate('Fill in the details to create a new contact.')
      })
    );
  };
};


export const showTimekeepingSidePanel = (day: string | null, data: any, isLoading: boolean, stats: any) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'timekeepingView',
        showSidePanel: true,
        size: 'md',
        isExpanded: false,
        onCancel: () => dispatch(hideSidePanel()),
        day,
        data,
        isLoading,
        stats
      })
    );
  };
};

export const showCreateLCMCaseSidePanel = () => ({
  type: 'SHOW_SIDE_PANEL',
  payload: {
    type: 'createLCMCase',
    size: 'md',
    isExpanded: false,
  },
});

export const showCreateProjectSidePanel = () => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'createProject',
        showSidePanel: true,
        size: 'md',
        onCancel: () => dispatch(hideSidePanel()),
      })
    );
  };
};

export const showProposeCaseSidePanel = (lawyerId: string) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'proposeCase',
        showSidePanel: true,
        size: 'md',
        onCancel: () => dispatch(hideSidePanel()),
        lawyerId,
      })
    );
  };
};


export const showFileReaderSidePanel = (fileUrl: string, fileType: string) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'fileReader',
        showSidePanel: true,
        size: 'md',
        fileType: fileType || '',
        fileUrl,
        onCancel: () => dispatch(hideSidePanel()),
        loading: true,
      })
    );
  };
};

export const showExtractedContentSidePanel = (filename: string, extractedText: string) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'extractedContent',
        showSidePanel: true,
        size: 'md',
        message: filename,
        icon: <PiFileTextLight className='w-6 h-6 text-gray-600' />,
        filename,
        content: extractedText,
        onCancel: () => dispatch(hideSidePanel()),
      })
    );
  };
};

export const ShowTransactionDetailsPanel = (transaction_id: string) => {
  return (dispatch: Dispatch) => {
    dispatch(showSidePanel({
      type: 'transactionDetails',
      showSidePanel: true,
      size: 'md',
      onConfirm: () => { },
      onCancel: () => { },
      transaction_id: transaction_id,
    }));
  }
};

export const showDocumentCustomizationPanel = (
  matterUuid: string,
  documentTypeId: string,
  documentType: 'draft' | 'insight',
  documentName: string,
) => {
  return (dispatch: Dispatch) => {
    dispatch(
      showSidePanel({
        type: 'documentCustomization',
        showSidePanel: true,
        size: 'md',
        mb: false,
        matterUuid,
        documentTypeId,
        documentType,
        documentName,
        message: `Customize ${documentName}`,
        icon: <PiSlidersHorizontalLight className="w-6 h-6 text-gray-600" />,
        subMsg: `Configure custom instructions and reference attachments for this ${documentType}.`,
        onCancel: () => dispatch(hideSidePanel()),
      })
    );
  };
};
